import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { AppState } from "../store";

export interface UserDataState {
  userID: string;

}

const initialState: UserDataState = {
  userID: null,

  
};

export const userDataSlice = createSlice({
  name: "userData",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setUserID: (state, action: PayloadAction<any>) => {
      state.userID = action.payload;
    },
  
  },
});

export const {
  setUserID,
  
} = userDataSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectUserID = (state: AppState) => state.userData.userID;


export default userDataSlice.reducer;
